import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';

@Component({
	selector: 'aspect-ratio-container',
	templateUrl: './aspect-ratio-container.component.html',
	styleUrls: ['./aspect-ratio-container.component.scss'],
	standalone: false
})
export class AspectRatioContainerComponent implements OnInit, OnChanges, OnDestroy {
	@Input() public ratio!: string;

	private aspectRatio!: number;
	private resizeObserver!: ResizeObserver;

	constructor (private elementRef: ElementRef) {}

	public ngOnInit (): void {
		const nativeElement = this.elementRef.nativeElement;
		this.updateRatio(this.ratio);

		this.resizeObserver = new ResizeObserver(() => {
			this.resize(this.aspectRatio);
		});
		this.resizeObserver.observe(nativeElement.parentElement);

		this.resize(this.aspectRatio);
	}

	public ngOnChanges (changes: SimpleChanges): void {
		if (changes.ratio) {
			this.updateRatio(changes.ratio.currentValue);
		}
	}

	private updateRatio (ratio: string): void {
		if (!ratio) {
			throw new Error('Property binding `ratio` is required');
		}

		const match = ratio.match(/(\d+):(\d+)/);
		if (!match) {
			throw new Error('Property binding `ratio` is invalid');
		}

		this.aspectRatio = parseFloat(match[1]) / parseFloat(match[2]);
		this.resize(this.aspectRatio);
	}

	public ngOnDestroy (): void {
		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
		}
	}

	private resize (aspectRatio: number): void {
		const nativeElement = this.elementRef.nativeElement;
		const parentElement = nativeElement.parentElement;
		const boundingRect = parentElement.getBoundingClientRect();

		let containerWidth = boundingRect.width;
		let containerHeight = boundingRect.height;

		// Minus parent padding
		const containerStyle = window.getComputedStyle(parentElement);
		containerWidth -= parseFloat(containerStyle.paddingLeft) + parseFloat(containerStyle.paddingRight);
		containerHeight -= parseFloat(containerStyle.paddingTop) + parseFloat(containerStyle.paddingBottom);

		// Minus element margin
		const elementStyle = window.getComputedStyle(nativeElement);
		containerWidth -= parseFloat(elementStyle.marginLeft) + parseFloat(elementStyle.marginRight);
		containerHeight -= parseFloat(elementStyle.marginTop) + parseFloat(elementStyle.marginBottom);

		const containerRatio = containerWidth / containerHeight;
		if (aspectRatio > containerRatio) {
			nativeElement.style.width = `${Math.ceil(containerWidth)}px`;
			nativeElement.style.height = `${Math.ceil(containerWidth / aspectRatio)}px`;
		} else {
			nativeElement.style.width = `${Math.ceil(containerHeight * aspectRatio)}px`;
			nativeElement.style.height = `${Math.ceil(containerHeight)}px`;
		}
	}
}
